import { Injectable, signal } from '@angular/core';

/**
 * Estado global cuando el API devuelve 403 de RBAC (`msg` tipo “Permiso denegado…”).
 * El interceptor actualiza estas señales; `AppShellComponent` pinta overlay/banner.
 */
@Injectable({ providedIn: 'root' })
export class PermissionDeniedUiService {
  readonly blockingOverlay = signal<{ message: string } | null>(null);
  readonly bannerMessage = signal<string | null>(null);
  private bannerTimer?: ReturnType<typeof setTimeout>;

  showBlockingOverlay(message: string): void {
    this.blockingOverlay.set({ message });
  }

  /** Para mutaciones (POST/PATCH) o GET “globales” que no deben tapar la vista. */
  showBanner(message: string): void {
    if (this.bannerTimer !== undefined) {
      clearTimeout(this.bannerTimer);
    }
    this.bannerMessage.set(message);
    this.bannerTimer = setTimeout(() => {
      this.bannerMessage.set(null);
      this.bannerTimer = undefined;
    }, 8000);
  }

  clearBlockingOverlay(): void {
    this.blockingOverlay.set(null);
  }

  dismissBanner(): void {
    if (this.bannerTimer !== undefined) {
      clearTimeout(this.bannerTimer);
      this.bannerTimer = undefined;
    }
    this.bannerMessage.set(null);
  }
}
